import { Page } from "commonAssets/pages/Page";
import { loading, outputDiv, userLanguage, i18n } from "commonAssets/js/constants";
import { createElement, loadingGif } from "commonAssets/js/helpers";
import { makeStandardContactPage } from "commonAssets/pages/Page/contact";
import { renderLegalOptionsTable } from "commonAssets/pages/Page/home";

export class CustomPage extends Page {
    banks_broker_institutions() {
        const Pages = this.pages;
        Pages.forEach(page => {
            if (this.slug !== page.PageName) return;

            const PageTitle = createElement("h2", { class: "PageTitle" }, [], `Instructions for Filing an Electronic Claim`);
            const Separator = createElement("hr");
            const Instructions = createElement("div", { id: "efiling-instructions" }, [], `
            <h4 class="mt-3 mb-3"><strong>OVERVIEW</strong></h4>
            <p>Electronic claim submission is available to Banks, Brokers, and other Institutions or claim prepares filing on behalf of themselves or others that purchased or otherwise acquired DZS common stock between May 4, 2022, and November 9, 2023, inclusive, and who were damaged thereby.</p>
            <p class="text-decoration-underline">Important</p>
            <ul>
                <li>Submissions must be entered via the <strong>Electronic Claim Portal</strong></li>
                <li>Submissions missing documentation and/or not in compliance with the Electronic Filing Instructions may be rejected, in whole or in part.</li>
                <li>Submissions are not considered to be received unless confirmation is provided via email. If you do not receive confirmation within 10 days of your submission, please email <a href="mailto:Info@DZSISecuritiesSettlement.com">Info@DZSISecuritiesSettlement.com</a> with the subject:   (Enter your filing entity) | DZS Inc. Securities | Missing Confirmation</li>
            </ul>
            <hr>
            <h4 class="mt-3 mb-3"><strong>ELECTRONIC CLAIM PORTAL</strong></h4>
            <p><span style="color: red;">⚠</span> <a target="_blank" href="third-party-filer">Click here to access the Electronic Claim Portal</a></p>
            <hr>
            <h4 class="mt-3 mb-3"><strong>DATA FILES</strong></h4>
            <p>Download and complete the Beneficial Owner template and Transaction template as directed in the Electronic Claim Filing Instructions.</p>
            <p><span style="color: red;">⚠</span> <a target="_blank" href="https://angeion-public.s3.us-east-1.amazonaws.com/www.dzsisecuritiessettlement.com/docs/DZS_Electronic+Claim+Filing+Instructions.pdf">Click here to download the Electronic Filing Instructions</a></p>
            <p><span style="color: red;">⚠</span> <a target="_blank" href="https://angeion-public.s3.us-east-1.amazonaws.com/www.dzsisecuritiessettlement.com/docs/Beneficial+Owner+Information+template.csv">Click here to download the Beneficial Owner Template</a></p>
            <p><span style="color: red;">⚠</span> <a target="_blank" href="https://angeion-public.s3.us-east-1.amazonaws.com/www.dzsisecuritiessettlement.com/docs/Transaction+Information+template.csv">Click here to download the Transaction Template</a></p>
            <hr>
            <h4 class="mt-3 mb-3"><strong>DOCUMENTATION</strong></h4>
            <ul id='banks-broker-institutions-docs'>
                <li>
                    <strong>Claim Form</strong> <span style="color: red;">⚠</span> <a target="_blank" href="https://angeion-public.s3.amazonaws.com/www.dzsisecuritiessettlement.com/docs/DZS%20-%20Proof%20of%20Claim%20Form.pdf">Click here to download the Claim Form</a>
                    <ul><li>Please complete the Claimant Information page (Part I) and complete the signature portion under Part IV. Release of Claims and Signature.<br>One Claim Form will serve as the “master” for all Claims provided in the electronic data files.</li></ul>
                </li>
                <li>
                    <strong>Proof of Authority to File</strong>
                    <ul><li>Please provide a current document verifying you are authorized to file and sign claims on behalf of the Claimants that you have submitted Claims for.</li></ul>
                </li>
                <li>
                    <strong>Signature Verification</strong>
                    <ul><li>Please provide verification that the individual signing the Claim Form is authorized to do so, including, but not limited to By-Laws, Corporate Resolution, or a notarized Affidavit.</li></ul>
                </li>
                <li>
                    <strong>Declaration of Data Source</strong>
                    <ul><li>Please provide a notarized Affidavit or signed letter on Company letterhead that lists the number of separate claims and transactions submitted; attests to the source, truth, and accuracy of the data for each claim; and is executed by an authorized signatory listed on the signature verification and includes the capacity of the signatory.</li></ul>
                </li>
                <li>
                    <strong>Additional Documentation May Be Requested</strong>
                </li>
            </ul>
            `);

            const pageElement = createElement("div", { class: "page" }, [PageTitle, Separator, Instructions]);
            outputDiv.appendChild(pageElement);
        });
        loadingGif(loading, "hide", 250);
    }
}

export const contactPage = (params) => {
    console.log("[Contact Page] ...");
    // define the constants
    const slug = params.slug;
    const page = params.pages.find(page => page.PageName === slug);
    // define the elements
    const pageTitle = createElement("h2", { class: "page-title mt-2 mb-4", }, [], page.PageTitle);
    const pageContent = createElement("div", { class: "page-content row", });
    const pageDiv = createElement("div", { class: "page-div", }, [pageTitle, pageContent]);
    const divImptDates = createElement("div", { class: "my-5 mx-auto", id: "ImportantDates", style: "max-width: 512px;", }, [], params.dates.card());
    const pageColumns = createElement("div", { class: "col-12 col-md-7" });
    // contact column
    if (page.PageContent.length > 0) {
        // make standard contact page
        makeStandardContactPage(params, page, userLanguage, pageColumns);
        pageContent.appendChild(pageColumns);
    }
    else {
        const contactInfoNa = createElement("p", { class: "fst-italic" }, [], `No contact information found.`);
        pageColumns.appendChild(contactInfoNa);
        pageContent.appendChild(pageColumns);
    }
    // remove the my-5 and mx-auto classes from the divImptDates element
    if (divImptDates.classList.contains('my-5', 'mx-auto')) {
        divImptDates.classList.remove('my-5', 'mx-auto');
    }
    // important dates column
    const imptDatesColumn = createElement("div", { class: "col-12 col-md-5" }, [divImptDates]);
    pageContent.appendChild(imptDatesColumn);
    outputDiv.appendChild(pageDiv);
    loadingGif(loading, "hide", 250);
};

export const homePage = (params) => {
    console.log("[Home] ...");
    // Get the page slug from the URL and initialize the page object
    const slug = params.slug;
    const page = params.pages.find(page => page.PageName === slug);
    // HTML elements for the page
    const pageTitle = createElement("h2", { class: "page-title mt-2 mb-4 d-none", "aria-label": i18n.getTranslation("home_page_aria_title") }, [], page.PageTitle);
    const pageBody = createElement("div", { class: "page-body", });
    const pageAlert = createElement("div", { class: "alert border-dark bg-light text-dark mb-3 pt-4 text-center", id: "pageAlert", }, [], page.PageAlert);
    const pageHeader = createElement("p", { class: "text-center h2 my-5 pageHeader", id: "pageHeader_" + slug, }, [], page.PageHeader);
    const pageSubHeader1 = createElement("p", { class: "text-center fw-bold fst-italic pageSubHeader1", id: "pageSubHeader1_" + slug, }, [], page.PageSubHeader1);
    const pageSubHeader2 = createElement("p", { class: "text-center fst-italic pageSubHeader2", id: "pageSubHeader2_" + slug, }, [], page.PageSubHeader2);
    const pageContent = createElement("div", { class: "mb-3 pageContent", id: "pageContent_" + slug, }, [], page.PageContent);
    const pageFooter = createElement("div", { class: "py-3", id: "pageFooter", }, [], page.PageFooter);
    // Legal Rights and Options Table
    const optionsDIV = renderLegalOptionsTable(slug, page);
    const pageElement = createElement("div", { class: "page", id: slug, }, [
        Boolean(page.PageAlert) ? pageAlert : '',
        pageHeader,
        pageSubHeader1,
        pageSubHeader2,
        optionsDIV,
        pageFooter,
        pageContent,
    ]);
    const pageDiv = createElement("div", { class: "home-container", }, [pageTitle, pageBody]);
    // Append the page elements to the output div
    outputDiv.appendChild(pageElement);
    outputDiv.appendChild(pageDiv);
    loadingGif(loading, "hide", 100);
};
